import { render, staticRenderFns } from "./PresentAsComponent.vue?vue&type=template&id=20d88be6&scoped=true"
import script from "./PresentAsComponent.vue?vue&type=script&lang=js"
export * from "./PresentAsComponent.vue?vue&type=script&lang=js"
import style0 from "./PresentAsComponent.vue?vue&type=style&index=0&id=20d88be6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d88be6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20d88be6')) {
      api.createRecord('20d88be6', component.options)
    } else {
      api.reload('20d88be6', component.options)
    }
    module.hot.accept("./PresentAsComponent.vue?vue&type=template&id=20d88be6&scoped=true", function () {
      api.rerender('20d88be6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/quoteBuilder/components/PresentAsComponent.vue"
export default component.exports